var r = /* @__PURE__ */ ((M) => (M.SMALL = "s", M.MEDIUM = "m", M.LARGE = "l", M.MAXIMUM = "x", M.CUSTOM = "c", M))(r || {});
export {
  r as INPUT_WIDTH
};
//# sourceMappingURL=imask.js.map
